const { protocol } = window.location;

export const thirdPagePath = '/inner/third-page'
export const thirdPageName = 'inner__third-page'
export const thirdPageMap = {
  '/lowcode': `${protocol}//magic-lowcode.sit.sf-express.com`
}
